import { numberUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

interface RefundRewardRedemptionProps {
  readonly redeemReward?: string | null;
  readonly redeemAmount?: number;
}

export default function RefundRewardRedemption({ redeemAmount, redeemReward }: RefundRewardRedemptionProps) {
  return redeemReward ? (
    <div className="mb-4">
      <Text weight="semibold" className="py-2">
        Redeemed Reward
      </Text>
      <div className="flex justify-between border-t py-2">
        <Text>{redeemReward}</Text>
        <Text>{Number.isFinite(redeemAmount) && `(${numberUtils.formatCurrency(redeemAmount, 'Rp.')})`}</Text>
      </div>
    </div>
  ) : null;
}
